import FJAIImageListContainer from '../../../../common/combineComponents/FJAIImageListContainer/container/FJAIImageListContainer';
import FJSwitchButton from '../../../../common/components/FJSwitchButton/FJSwitchButton';
import FJTextarea from '../../../../common/components/FJTextarea/FJTextarea';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJAiVideoDubInputContainer from '../container/FJAiVideoDubInputContainer';
import styles from './FJAiVideoDubLeft.module.less';
import FJHelpIcon from '../../../../assets/svg/help.svg?react';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import PropTypes from 'prop-types';
import { AI_VIDEO_DUB_USE_CREDIT } from '../../../../redux/slices/FJSliceAiVideoDub';
import classNames from 'classnames';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';

const FJAiVideoDubLeft = props => {
    const {
        prompts,
        removeOriginAudioActive,
        onChangePrompts,
        onChangeRemoveOriginAudio,
        onGenerate,
        taskStatus,
        isFree,
        useCredit,
        freeNumCreation,
        disable,
        videoInfo,
    } = props;

    const renderTrigger = config => {
        return (
            <div className={styles.switch_remove_origin_audio_icon} onClick={config.onClick} ref={config.ref}>
                <FJHelpIcon />
            </div>
        );
    };

    const renderOverlay = config => {
        return (
            <div className={styles.switch_remove_origin_audio_desc} ref={config.ref}>
                {FJLocalStore._('remove-origin-audio-desc')}
            </div>
        );
    };

    return (
        <FJAppLeft className={styles.left_panel}>
            <FJVerticalScroller className={styles.left_panel_scroller}>
                <FJAiVideoDubInputContainer disable={disable} />

                <FJAIImageListContainer position={{ top: 108, left: 478 }} />

                <div className={styles.prompts}>
                    <div className={styles.prompts_title}>{FJLocalStore._('video-description')}</div>
                    <FJTextarea
                        className={styles.prompts_textarea}
                        text={prompts}
                        onChange={onChangePrompts}
                        maxLength={2000}
                        disabled={disable}
                        placeholder={FJLocalStore._('prompt-placeholder')}
                    />
                </div>

                <div className={classNames(styles.switch_remove_origin_audio, { [styles.disabled]: disable })}>
                    <div className={styles.switch_remove_origin_audio_title}>
                        {FJLocalStore._('remove-origin-audio')}
                        <FJDropdownNew
                            renderTrigger={renderTrigger}
                            useAnchorBody
                            placement='rightTop'
                            trigger='click'
                            renderOverlay={renderOverlay}
                            offsetLeft={8}
                            offsetTop={-11}
                        />
                    </div>

                    <FJSwitchButton
                        active={removeOriginAudioActive}
                        onChange={onChangeRemoveOriginAudio}
                        className={styles.switch_remove_origin_audio_switch}
                    />
                </div>
            </FJVerticalScroller>

            <FJGenerateButton
                className={styles.generate_btn}
                taskStatus={taskStatus}
                onClick={onGenerate}
                isFree={isFree}
                useCredit={Math.max(useCredit, AI_VIDEO_DUB_USE_CREDIT)}
                freeNumCreation={freeNumCreation}
                isShowUsageDetail={videoInfo && videoInfo.src ? true : false}
            />
        </FJAppLeft>
    );
};

FJAiVideoDubLeft.propTypes = {
    prompts: PropTypes.string,
    removeOriginAudioActive: PropTypes.bool,
    onChangePrompts: PropTypes.func,
    onChangeRemoveOriginAudio: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    isFree: PropTypes.bool,
    useCredit: PropTypes.number,
    freeNumCreation: PropTypes.number,
    disable: PropTypes.bool,
    videoInfo: PropTypes.object,
};

export default FJAiVideoDubLeft;
